import { Pipe, PipeTransform } from '@angular/core';
import { FiduciaryTypeEnum } from '../../fiduciaries/enums/fiduciary-type.enum';

@Pipe({
  name: 'fiduciaryTypeName'
})
export class FiduciaryTypeNamePipe implements PipeTransform {
  transform(value: FiduciaryTypeEnum): string {
    switch (value) {
      case FiduciaryTypeEnum.PowerOfAttorney:
        return $localize`Power of Attorney`;
      case FiduciaryTypeEnum.Guardianship:
        return $localize`Guardianship`;
      case FiduciaryTypeEnum.Trusteeship:
        return $localize`Trusteeship`;
    }
  }
}
